
import { Phone, Mail, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useState } from 'react';

const ContactCTA = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <div className="mt-12 text-center">
      <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-900 mb-4">
          Ready to Get Started?
        </h3>
        <p className="text-gray-600 mb-6">
          Talk to our infrastructure experts and get a custom solution tailored to your needs.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            className="bg-nexx-green hover:bg-nexx-green/90 text-white px-6 py-3 ring-vibrate"
            asChild
          >
            <a href="tel:+12402198426" className="flex items-center gap-2">
              <Phone className="h-4 w-4" />
              Call Now
            </a>
          </Button>
          <Button 
            variant="outline" 
            className="border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white px-6 py-3"
            asChild
          >
            <a href="mailto:sales@nexx.net" className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              Email Sales
            </a>
          </Button>
          <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger asChild>
              <Button 
                variant="outline" 
                className="border-blue-500 text-blue-600 hover:bg-blue-500 hover:text-white px-6 py-3"
              >
                <Users className="h-4 w-4 mr-2" />
                Apply for Wholesale Access
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] p-0 overflow-hidden">
              <DialogTitle className="sr-only">Wholesale Application</DialogTitle>
              <DialogDescription className="sr-only">
                Fill out this form to apply for wholesale access to our services
              </DialogDescription>
              <div className="w-full h-[85vh] p-4">
                <iframe 
                  src="https://tally.so/embed/nPWp8e?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                  loading="lazy" 
                  width="100%" 
                  height="100%"
                  style={{ border: 'none', borderRadius: '8px' }}
                  title="Wholesale Application"
                  className="w-full h-full rounded-lg"
                />
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;
